import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from "@mui/material";
import { Block } from "../../models/block";
import { useDispatch } from "react-redux";
import { updateBlockDynamicProperties } from "../../store/game/gameSlice";

interface ArrowSettingsProps {
  block: Block;
}

export const ArrowSettings: React.FC<ArrowSettingsProps> = ({ block }) => {
  const dispatch = useDispatch();
  const currentDirection = block.dynamicProperties?.direction || "right";

  const handleDirectionChange = (event: any) => {
    dispatch(
      updateBlockDynamicProperties({
        blockId: block.id,
        properties: { direction: event.target.value },
      })
    );
  };

  return (
    <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="subtitle1" fontWeight={600}>
        Configure Arrow Direction
      </Typography>
      <FormControl fullWidth size="small">
        <InputLabel id="arrow-direction-label">Direction</InputLabel>
        <Select
          labelId="arrow-direction-label"
          id="arrow-direction-select"
          value={currentDirection}
          label="Direction"
          onChange={handleDirectionChange}
        >
          <MenuItem value="up">Up (▲)</MenuItem>
          <MenuItem value="right">Right (▶)</MenuItem>
          <MenuItem value="down">Down (▼)</MenuItem>
          <MenuItem value="left">Left (◀)</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};